export function linkify(text: string) {
  return text.replace(
    /(https:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim,
    '<a href="$1" target="_blank">$1</a>',
  );
}
